/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2023-12-01 12:48:04
 * @FilePath: \frontend\src\permission.js
 */
import router from './router';
import { resetRouter, addRoutes } from './router';
import store from './store';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
// import { isLogin, functionList, getUserRole } from '@/api/user';
import {
  adminCheck,
  functionList,
  setLastLogin,
  userCheck,
  dashboardAccessCheck,
  maintenanceAccessCheck,
} from '@/api/user';
import { getServiceList } from '@/api/service';
import { getSubGHzUdpMode } from '@/api/sys';
import { initFunctionList } from '@/utils/userFunctionList';
import getPageTitle from '@/utils/getPageTitle';
// import { roleId, permissionId } from '@/utils/const'
// import permissionJson from './permission.json';
import { fetchUserAttributes, fetchAuthSession } from 'aws-amplify/auth';
import { errorMsg, warningMsg } from '@/utils/message';
import { i18n } from '@/Lang/index';
import { ElNotification, ElMessage } from 'element-plus';
import { amplifySignOut } from '@/utils/auth';

NProgress.configure({
  showSpinner: false,
}); // NProgress Configuration

const whiteList = ['/login']; // no redirect whitelist

const userUnregisterdNotification = {
  title: i18n.global.t('request.error'),
  message: errorMsg.Login_failed,
  type: 'error',
  duration: 2000,
  customClass: 'notify',
};

const noViewablePageNotification = {
  title: i18n.global.t('request.error'),
  message: errorMsg.No_viewable_pages,
  type: 'error',
  duration: 2000,
  customClass: 'notify',
};

const loginTimeoutMessage = {
  message: warningMsg.Login_timeout,
  type: 'warning',
  duration: 5 * 1000,
  customClass: 'notify',
};

let isRefresh = true;
let hasRouter = false;
let lastServiceSync = 0;
const SERVICE_REFRESH_INTERVAL = 5 * 60 * 1000; // 5 minutes

export function getIsRefresh() {
  return isRefresh;
}

export function setIsRefresh(value) {
  isRefresh = value;
}

export function getHasrouter() {
  return hasRouter;
}

export function setHasrouter(value) {
  hasRouter = value;
}

async function refreshServiceMaster() {
  const now = Date.now();
  if (now - lastServiceSync < SERVICE_REFRESH_INTERVAL) {
    return;
  }

  const serviceList = await getServiceList();
  await store.dispatch('service/setServiceList', serviceList);
  lastServiceSync = now;
}

export async function reinitializeRouter() {
  try {
    const mode = store.getters.mode || 0;
    const isAdmin = await adminCheck();
    const hasDashboardAccess = await dashboardAccessCheck();
    const hasMaintenanceAccess = await maintenanceAccessCheck();

    const data = await functionList({
      isAdmin: isAdmin,
      hasDashboardAccess: hasDashboardAccess,
      hasMaintenanceAccess: hasMaintenanceAccess,
    });

    if (data.status === 0) {
      const userFunctionList = initFunctionList(data.data, mode, isAdmin);
      resetRouter();
      addRoutes(userFunctionList);
      router.options.routes = userFunctionList;
      await refreshServiceMaster();
      console.log('Router reinitialized after service change');
      return { status: 0 };
    } else {
      console.error('Failed to get function list for router reinitialization');
      return { status: -1 };
    }
  } catch (error) {
    console.error('Error reinitializing router:', error);
    return { status: -1 };
  }
}

export async function routeControlBefore(to, from, next) {
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);

  // determine whether the user has logged in
  // route control and add paths depends on user role and permission
  await fetchUserAttributes()
    .then(async (attributes) => {
      // user is Authenticated
      const user_tenantId = attributes['custom:tenantId'];

      if (store.getters.tenantId !== user_tenantId) {
        store.dispatch('user/setTenantId', user_tenantId);
      }
      // update token (token refresh)
      await fetchAuthSession().then((session) => {
        const idToken = session.tokens.idToken;
        const token = idToken.toString();
        const expire = idToken.payload.exp * 1000;
        if (store.getters.token.token !== token || store.getters.token.expire !== expire) {
          store.dispatch('user/setToken', { token: token, expire: expire });
        }
      });

      if (to.path === '/login') {
        // if is logged in, redirect to the home page
        next('/');
        NProgress.done();
      } else {
        // store.dispatch('user/getInfo')
        // router don't have dynamic routes
        if (!getHasrouter() || from.path === '/login') {
          await getSubGHzUdpMode().then(async (data) => {
            if (data.status === 0) {
              const mode = data.data.mode;
              store.dispatch('user/setMode', mode);
              const userExist = await userCheck();
              if (userExist) {
                setLastLogin();
                const isAdmin = await adminCheck();
                const hasDashboardAccess = await dashboardAccessCheck();
                const hasMaintenanceAccess = await maintenanceAccessCheck();
                await functionList({
                  isAdmin: isAdmin,
                  hasDashboardAccess: hasDashboardAccess,
                  hasMaintenanceAccess: hasMaintenanceAccess,
                }).then(async (data) => {
                  if (data.status === 0) {
                    const userFunctionList = initFunctionList(data.data, mode, isAdmin);

                    // NOTE: Permission Check is Disabled
                    // permissionCheck(userFunctionList);

                    resetRouter();
                    addRoutes(userFunctionList);
                    router.options.routes = userFunctionList;
                    setHasrouter(true);

                    await refreshServiceMaster();
                    refresh(to, next);
                  } else {
                    await amplifySignOut().finally(() => {
                      ElNotification(noViewablePageNotification);
                      next(false);
                      NProgress.done();
                    });
                  }
                });
              } else {
                await amplifySignOut().finally(() => {
                  ElNotification(userUnregisterdNotification);
                  next(false);
                  NProgress.done();
                });
              }
            }
          });
        } else {
          await refreshServiceMaster();
          refresh(to, next);
        }
      }
    })
    .catch(async () => {
      // user is unauthenticated
      setIsRefresh(true);
      // token expire
      if (store.getters.token) {
        try {
          await amplifySignOut();
          ElMessage(loginTimeoutMessage);
          next('/login');
          NProgress.done();
        } catch {
          next(false);
          NProgress.done();
        }
      } else {
        if (whiteList.indexOf(to.path) !== -1) {
          // in the free login whitelist, go directly
          next();
        } else {
          // other pages that do not have permission to access are redirected to the login page.
          next('/login');
          NProgress.done();
        }
      }
    });
}

function refresh(to, next) {
  if (getIsRefresh()) {
    // triggered by initial routing from '/login' to '/'
    setIsRefresh(false);
    // route to same path, but beforeeach is evaluated again (route to corresponding new component)
    // prevent from returning '/login'
    next({
      ...to,
      replace: true,
    });
  } else {
    next();
  }
}

/*
function permissionCheck(userFunctionList) {
  // System Permission Check
  for (let i = 0; i < userFunctionList.length; i++) {
    if (userFunctionList[i].path === '/SystemInfo') {
      for (let j = 0; j < userFunctionList[i].children.length; j++) {
        if (userFunctionList[i].children[j].path === '/SystemNetwork') {
          if (!hasPermission(permissionId.Sys_Info_Sys_NWK)) userFunctionList[i].children.splice(j, 1);
        } else if (userFunctionList[i].children[j].path === '/SubGConfig') {
          if (!hasPermission(permissionId.Sys_Info_SubG)) userFunctionList[i].children.splice(j, 1);
        } else if (userFunctionList[i].children[j].path === '/subGwConfig') {
          if (!hasPermission(permissionId.Sys_Info_Sub_Gateway)) userFunctionList[i].children.splice(j, 1);
        } else if (userFunctionList[i].children[j].path === '/SystemTime') {
          if (!hasPermission(permissionId.Sys_Info_Sys_Clock)) userFunctionList[i].children.splice(j, 1);
        }
      }
      if (userFunctionList[i].children.length === 0) userFunctionList.splice(i, 1);
      break;
    }
  }

  // Map Permission Check
  if (!hasPermission(permissionId.Map)) {
    for (let i = 0; i < userFunctionList.length; i++) {
      if (userFunctionList[i].path === '/Map') {
        userFunctionList.splice(i, 1);
        break;
      }
    }
  }

  // Alert Permission Check
  for (let i = 0; i < userFunctionList.length; i++) {
    if (userFunctionList[i].path === '/AlertHistory') {
      for (let j = 0; j < userFunctionList[i].children.length; j++) {
        if (userFunctionList[i].children[j].path === '/AlertCondition') {
          if (!hasPermission(permissionId.Alert_Condition)) userFunctionList[i].children.splice(j, 1);
        } else if (userFunctionList[i].children[j].path === '/AlertHistory') {
          if (!hasPermission(permissionId.Alert_History)) userFunctionList[i].children.splice(j, 1);
        } else if (userFunctionList[i].children[j].path === '/AlertEmail') {
          if (!hasPermission(permissionId.Alert_Email)) userFunctionList[i].children.splice(j, 1);
        }
      }
      if (userFunctionList[i].children.length === 0) userFunctionList.splice(i, 1);
      break;
    }
  }

  // UserManagement Permission check
  if (!hasPermission(permissionId.User_Mgr)) {
    for (let i = 0; i < userFunctionList.length; i++) {
      if (userFunctionList[i].path === '/UserManagement') {
        userFunctionList.splice(i, 1);
        break;
      }
    }
  }

  // SencerLog Permission Check
  if (!hasPermission(permissionId.SensorCSV_Log)) {
    for (let i = 0; i < userFunctionList.length; i++) {
      if (userFunctionList[i].path === '/CSVLog') {
        userFunctionList.splice(i, 1);
        break;
      }
    }
  }

  // TFCard Permission Check
  if (!hasPermission(permissionId.Tf_Card_Remove) && !hasPermission(permissionId.Tf_Card_Usage)) {
    for (let i = 0; i < userFunctionList.length; i++) {
      if (userFunctionList[i].path === '/TFCardInfo') {
        userFunctionList.splice(i, 1);
        break;
      }
    }
  }
}
*/

export function routeControlAfter() {
  // finish progress bar
  NProgress.done();
}

/*
export function hasPermission(code) {
  // console.log('hasPermission', store.getters.role_id, store.getters.user_name)
  const permission = permissionJson[code];
  if (permission && store.getters.role_id) {
    const roleP = permission[store.getters.role_id];
    return roleP;
  }
  return false;
}
*/
